import fetchWrapper from "fetchWrapper";

const API_BASE = `${process.env.REACT_APP_API_URL}/user-equipment`;

export const checkEquipmentExists = async (cardUserId, serialNumber = "") => {
  try {
    const response = await fetchWrapper(
      `${API_BASE}/check-exists`,
      JSON.stringify({ card_user_id: cardUserId, serial_number: serialNumber }),
      "POST"
    );
    const result = await response.json();

    // Normalizar respuesta del backend
    if (result.success && result.data) {
      return result.data;
    } else {
      // Si el backend devuelve formato incompleto, normalizarlo
      return {
        exists: result.exists || false,
        user_has_equipment: result.user_has_equipment || false,
        other_users_count: result.other_users_count || 0,
        serial_checked: result.serial_checked || serialNumber,
      };
    }
  } catch (error) {
    // Propagar errores de autenticación/permisos tal como vienen
    throw error;
  }
};

export const registerEquipment = async (equipmentData, imageFile = null) => {
  try {
    const formData = new FormData();

    Object.keys(equipmentData).forEach((key) => {
      if (equipmentData[key]) {
        formData.append(key, equipmentData[key]);
      }
    });

    if (imageFile) formData.append("image", imageFile);

    const response = await fetchWrapper(`${API_BASE}/register`, formData, "POST");
    return await response.json();
  } catch (error) {
    // Propagar errores de autenticación/permisos tal como vienen
    throw error;
  }
};

export const getUserEquipment = async (cardUserId) => {
  try {
    const response = await fetchWrapper(`${API_BASE}/user/${cardUserId}`);
    return await response.json();
  } catch (error) {
    // Propagar errores de autenticación/permisos tal como vienen
    throw error;
  }
};

export const getEquipmentUsers = async (serialNumber) => {
  try {
    const response = await fetchWrapper(`${API_BASE}/equipment/${serialNumber}/users`);
    return await response.json();
  } catch (error) {
    // Propagar errores de autenticación/permisos tal como vienen
    throw error;
  }
};

export const getEquipmentById = async (equipmentId) => {
  try {
    const response = await fetchWrapper(`${API_BASE}/${equipmentId}`);
    return await response.json();
  } catch (error) {
    // Propagar errores de autenticación/permisos tal como vienen
    throw error;
  }
};

export const updateEquipment = async (equipmentId, equipmentData, imageFile = null) => {
  try {
    const url = `${API_BASE}/${equipmentId}`;

    if (imageFile) {
      const formData = new FormData();
      formData.append("_method", "PUT");
      Object.keys(equipmentData).forEach((key) => {
        if (equipmentData[key]) {
          formData.append(key, equipmentData[key]);
        }
      });
      formData.append("image", imageFile);
      const response = await fetchWrapper(url, formData, "POST");
      return await response.json();
    } else {
      const response = await fetchWrapper(url, JSON.stringify(equipmentData), "PUT");
      return await response.json();
    }
  } catch (error) {
    // Propagar errores de autenticación/permisos tal como vienen
    throw error;
  }
};

export const deleteEquipment = async (equipmentId) => {
  try {
    const response = await fetchWrapper(`${API_BASE}/${equipmentId}`, undefined, "DELETE");
    return await response.json();
  } catch (error) {
    // Propagar errores de autenticación/permisos tal como vienen
    throw error;
  }
};
